/* eslint-disable react/display-name */
import React from 'react';
import styled from 'styled-components';

import { IconProps } from './iconInterfaces';

export const AqiICon = ({ 
    symbolFillColor,
    symbolFillOpacity,
    width,
    height 
}: IconProps) =>
    <Container>
        <svg width={width} height={height} x='3.5' y='3' viewBox='0 0 24 24'>
            <g fill={symbolFillColor} opacity={symbolFillOpacity}>
                <circle cx='0.9' cy='7' r='0.9'/>
                <circle cx='0.9' cy='10' r='0.9'/>
                <path d='M17.74,11.66a.76.76,0,0,0-1-.17,4.94,4.94,0,0,1-2.79,1V11.05a6.5,6.5,0,0,0,3.66-1.34.76.76,0,0,0,.17-1.05.75.75,0,0,0-1-.17,5,5,0,0,1-2.79,1V8.05a6.45,6.45,0,0,0,3.65-1.34.75.75,0,1,0-.87-1.22,5,5,0,0,1-2.78,1V1.9a2,2,0,0,0-2-1.9l-6,1a2,2,0,0,0-2,1.89V5.1a.9.9,0,1,0,0,1.8V8.1a.9.9,0,1,0,0,1.8v1.2a.9.9,0,1,0,0,1.8v3.2a2,2,0,0,0,2,1.9l6-.95a2,2,0,0,0,2-1.89V14.05a6.41,6.41,0,0,0,3.66-1.34A.75.75,0,0,0,17.74,11.66ZM5.7,16.2V2.76l6.4-1V6l-.19-.1A5.26,5.26,0,0,0,9.8,5.15a.75.75,0,1,0-.18,1.48,4.11,4.11,0,0,1,1.56.61,9.85,9.85,0,0,0,.92.46V9l-.18-.1a5.32,5.32,0,0,0-2.11-.78.75.75,0,1,0-.19,1.48,4,4,0,0,1,1.56.61,9.85,9.85,0,0,0,.92.46V12l-.18-.1a5.26,5.26,0,0,0-2.11-.78.75.75,0,1,0-.18,1.48,4.11,4.11,0,0,1,1.56.61,8.55,8.55,0,0,0,.91.46v1.54Z'/>
                <circle cx='0.9' cy='13' r='0.9'/>
            </g>
        </svg>
    </Container>;

const Container = styled.div`
    padding: 16% 0 0 16%;
`;